module.exports = __webpack_public_path__ + "static/media/dadEcard.91f5fd58.mp4";